var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHistoryIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#HistoryIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005D98",
  d: "M15.167 3.5c-5.799 0-10.5 4.702-10.5 10.5h-3.5l4.538 4.538.082.164L10.5 14H7a8.16 8.16 0 0 1 8.167-8.167A8.16 8.16 0 0 1 23.333 14a8.16 8.16 0 0 1-8.166 8.167 8.1 8.1 0 0 1-5.764-2.404L7.747 21.42a10.45 10.45 0 0 0 7.42 3.08c5.798 0 10.5-4.702 10.5-10.5s-4.702-10.5-10.5-10.5M14 9.333v5.834l4.958 2.94.899-1.494-4.107-2.438V9.333z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "HistoryIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h28v28H0z"
})))));
export default SvgHistoryIcon;